import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export function useDeploySimulatedBids() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: Parameters<typeof apiClient.deploySimulatedBids>[0]) =>
      await apiClient.deploySimulatedBids(vars),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [{ entity: "V4AdvReportByAd" }] });
    },
  });
}
